<h1 transloco="notFound">The page you are looking for is not available or doesn't exist.</h1>
<h1 class="icon-broken-heart"></h1>
<h1 transloco="notFoundSorry">Sorry about that!</h1>

<div class="text-center">
    <button class="ab_button filled" (click)="goBack()">Return</button>
</div>